import React, { useEffect, useState } from "react";
import { useOktaAuth } from "@okta/okta-react";
import { useNavigate } from "react-router-dom";
// import { injectModels } from "../redux/injectModels";
import { injectModels } from "../../redux/injectModels"
import PropTypes from "prop-types";
import { RoutesPath } from "../../constants";

const Login = (props) => {
    const { oktaAuth, authState } = useOktaAuth();
    const navigate = useNavigate();
    const [hasRedirected, setHasRedirected] = useState(false);
    const [loginInProgress, setLoginInProgress] = useState(false);

    const login = () => {
        if (loginInProgress) return;
        setLoginInProgress(true);
        oktaAuth.signInWithRedirect({ prompt: "login" });
    };

    useEffect(() => {
        const handleAuth = async () => {
            try {
                if (!authState || hasRedirected) return;

                props.loader.setLoading(true);

                if (authState.isAuthenticated) {
                    localStorage.setItem("isAuthenticated", "true");
                    localStorage.setItem("accessToken", authState.accessToken.accessToken);
                    localStorage.setItem("email", authState.idToken.claims.email);

                    const email = authState.idToken.claims.email;
                    const oktaName = authState.idToken.claims.name;

                    // Check user exists API
                    const existsRes = await props.auth.userExists();

                    if (!existsRes?.success) {
                        await props.auth.createNewUser({ email });
                    }

                    // Get user profile API
                    const profileRes = await props.auth.getSignedGetProfileList();
                    const apiName =
                        profileRes?.data?.user?.name ??
                        profileRes?.data?.data?.user?.name ??
                        "";

                    const finalName = apiName || oktaName || "";
                    localStorage.setItem("userName", finalName);

                    setHasRedirected(true);

                    setTimeout(() => {
                        navigate(RoutesPath.DASHBOARD, { replace: true });
                    }, 50);
                } else {
                    localStorage.setItem("isAuthenticated", "false");
                }
            } catch (e) {
                console.error("Authentication error:", e);
            } finally {
                props.loader.setLoading(false);
            }
        };

        handleAuth();
    }, [authState, hasRedirected]);

    return (
        <section className="login-logo container-fluid">

            <div className="row h-100 m-0">

                {/* LEFT SIDE */}
                <div className="col-12 col-md-5 p-0 left-wrapper">

                    {/* FULL HEIGHT ELEMENTS */}
                    <div className="vertical-line"></div>
                    <div className="blue-pill"></div>

                    {/* LOGO AT TOP */}
                    <div className="logo-wrapper">
                        <img src="/assets/img/Logo.png" className="main-logo" />
                    </div>

                    {/* CARD CENTERED */}
                    <div className="left-content">
                        <div className="card-login clickable-card" onClick={login}
                            role="button"
                            tabIndex={0}
                        >
                            <h4 className="mb-3">Welcome to GetSigned</h4>

                            <button className="btn btn-success w-100 sso-login-btn" onClick={login}>
                                <i className="fa fa-lock"></i> Login with SSO
                            </button>
                        </div>
                        <small className='all-reserved col-6'>© Getinge 2025 | All Rights Reserved</small>
                    </div>

                </div>

                {/* RIGHT */}
                <div className="col-12 col-md-7 p-0 right-container d-flex align-items-center justify-content-center">
                    <img src="/assets/img/login_img.png" className="login-illustration img-fluid" />
                </div>

            </div>

        </section>
    );
};

Login.propTypes = {
    auth: PropTypes.shape({
        userExists: PropTypes.func.isRequired,
        createNewUser: PropTypes.func.isRequired,
        getSignedGetProfileList: PropTypes.func.isRequired
    }).isRequired,
    loader: PropTypes.shape({
        setLoading: PropTypes.func.isRequired,
    }).isRequired
};

export default injectModels(["auth", "loader"])(Login);